<template>
  <div class="nk-block">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>
